import { CSSTransition } from 'react-transition-group';

const LoadingSpinner = ({ active, className }) => (
	<CSSTransition in={active} classNames="fade" timeout={700} unmountOnExit>
		<div className={`col-12 py-4${className ? ' ' + className : ''}`}>
			<i className="fa fa-2x fa-spinner fa-spin" />
		</div>
	</CSSTransition>
);

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./components/spinner/LoadingSpinner.js